<template>
    <div class="list-title">
        <slot>
            <slot name="left">{{title}}</slot>
            <slot class="list-title-desc" name="right">{{desc}}</slot>
        </slot>
    </div>
</template>
<script>
export default {
    name: 'ListTitle',
    props: {
        /**
         * 标题
         */
        title: {
            type: String,
        },
        /**
         * 描述内容
         */
        desc: {
            type: String,
        },
    },
};
</script>
<style lang="less">
@import "../../lib/style/util.less";
@import "../../lib/style/mixins.less";

.list-title {
    position: relative;
    padding: @list-padding-v / 2 @list-padding-h;
    font-size: 16px;
    line-height: 22px;
    .list-title-desc {
        float: right;
        font-size: 14px;
        line-height: 22px;
        color: @second-font-color;
    }
    // 粗字体
    &.bold {
        font-weight: bold;
    }
    // 更多上下边距
    &.more-padding {
        padding: @list-padding-v @list-padding-h;
    }
    // 前方红色标签
    &.label {
        padding-left: @list-padding-h + 8;
        &::before {
            position: absolute;
            content: '';
            left: 14px;
            top: 14px;
            font-size: @font-size-sub-title;
            width: 4px;
            height: 14px;
            border-radius: 4px;
            background-color: @primary-color;
        }
    }
}
</style>
